import React, {useContext} from 'react';
import {ErrorModal} from '@igp/shared/components/error';
import {ModalContext} from '@igp/shared/components/modal';
import {withTraceErrorBoundary} from '@igp/shared/otel';

import {EditUserForm} from '@features/bo-user/components/EditUserForm';
import type {BoUserViewModel} from '@features/bo-user/types';

function DevInner() {
    return (
        <>
            <div>Dev Page</div>
            <Test />
        </>
    );
}

export const Dev = withTraceErrorBoundary(DevInner, ErrorModal);

export function Test() {
    const {openModal} = useContext(ModalContext);
    const user: BoUserViewModel = {
        id: '1',
        firstName: 'testFN',
        username: 'testUN',
        lastName: 'testLN',
        email: 'test@test.com',
        aalGroup: {
            name: 'aal_managers_kr',
            id: 'd91d8683-34b7-4a68-8d99-a919c2a4d7c7',
        },
        role: {
            name: 'Agent Managers',
            id: 'd91d8683-34b7-4a68-8d99-a919c2a4d7c7',
        },
    };
    return (
        <>
            <button onClick={() => openModal({title: <div>Add User</div>, body: <EditUserForm />, styleParams: {maxWidth: 'xs'}})}>
                Add user
            </button>
            <button
                onClick={() => openModal({title: <div>Edit User</div>, body: <EditUserForm user={user} />, styleParams: {maxWidth: 'xs'}})}
            >
                Edit user
            </button>
        </>
    );
}
